import { useContext, createContext, useState, useEffect } from 'react';

const ScrollContext = createContext();

export function useScrollContext() {
    return useContext(ScrollContext);
}

function ScrollProvider({ children }) {  
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      }
      else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
      <ScrollContext.Provider value={{scrolled}}>
          {children}
      </ScrollContext.Provider>
  );
}

export default ScrollProvider;